export class PasswordEye {
    init() {
        let elements = document.querySelectorAll(".aib-password--toggle");

        if (elements) {
            elements.forEach((element) => {
                element.addEventListener('click', (e) => {
                    let target = e.target;
                    let input = target.nextElementSibling;

                    if (input.getAttribute("type") === "password") {
                        target.classList.add('fa-eye-slash');
                        input.setAttribute('type', 'text');
                    } else {
                        target.classList.remove('fa-eye-slash');
                        input.setAttribute('type', 'password');
                    }
                })
            })
        }
    }
}